angular.module('filters').filter('membershipPeriodFilter', ["$filter", function($filter) {
  return function(membership) {
    var end, start;
    start = moment(membership.start_date);
    end = moment(membership.expiration_date);
    if (membership.expiration_date) {
      if (start.format('YYYY') === end.format('YYYY')) {
        return `${start.format('MMM D')} - ${end.format('MMM D, YYYY')}`;
      } else {
        return `${start.format('MMM D, YYYY')} - ${end.format('MMM D, YYYY')}`;
      }
    } else {
      return `${start.format('MMM D, YYYY')} - no expiry date`;
    }
  };
}]);
